import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SubheaderComponent } from './subheader.component';

@NgModule({
  declarations: [
    SubheaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  
  ],
  exports: [SubheaderComponent],
})
export class SubheaderModule { }
